import { cn } from '@/platform/lib/utils';
import { MenuItems as HeadlessMenuItems } from '@headlessui/react';

const MenuItems = ({
    anchor = 'bottom start',
    modal = false,
    className,
    ...props
}) => (
    <HeadlessMenuItems
        transition
        modal={modal}
        anchor={{
            gap: 4,
            padding: 8,
            ...(typeof anchor === 'string' ? { to: anchor } : anchor),
        }}
        className={cn(
            'z-50 min-w-32 origin-top rounded bg-white py-1 shadow-lg outline-1 outline-gray-900/15 transition',
            'data-[anchor~=top]:origin-bottom',
            'data-closed:scale-95 data-closed:transform data-closed:opacity-0',
            'data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in',
            className
        )}
        {...props}
    />
);

export default MenuItems;
